package one.healthium.insights.ui.components.items

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEachIndexed
import one.healthium.domain.common.Insets
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ColorModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.AnchorState
import one.healthium.insights.ui.components.ContentEntryItem
import one.healthium.ui.common.utils.toPaddingValues
import one.healthium.ui.compose.theme.AppTheme
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun ContentRow(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Row,
    anchorState: AnchorState,
    onActionClicked: (ActionModel) -> Unit,
    actionButton: String?,
    onTextActionClicked: () -> Unit,
    isMetrics: Boolean,
) {
    Row(
        modifier = modifier
            .padding(entry.insets.toPaddingValues())
            .clickable(
                enabled = entry.action != null,
                onClick = { entry.action?.let(onActionClicked) }
            ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        entry.content.fastForEachIndexed { index, item ->
            val weight = entry.weights?.getOrNull(index)
            ContentEntryItem(
                modifier = if (weight != null && weight > 0f) {
                    Modifier.weight(weight)
                } else {
                    Modifier
                },
                entry = item,
                anchorState = anchorState,
                onActionClicked = onActionClicked,
                actionButton = actionButton,
                onTextActionClicked = onTextActionClicked,
                isMetrics = isMetrics,
            )
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun ContentRowPreview() {
    AppTheme {
        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
            ContentRow(
                entry = ContentEntry.Row(
                    content = listOf(
                        ContentEntry.PlainText("Plain text", null, null),
                        ContentEntry.Button(
                            text = "Button",
                            height = 37,
                            style = null,
                            containerColor = null,
                            action = ActionModel.Category(id = "id"),
                            insets = null
                        )
                    ),
                    weights = listOf(1f, 0f),
                    insets = Insets(16, 8, 16, 8),
                    action = null,
                ),
                anchorState = AnchorState(),
                onActionClicked = {},
                actionButton = null,
                onTextActionClicked = {},
                isMetrics = false,
            )

            ContentRow(
                entry = ContentEntry.Row(
                    content = listOf(
                        ContentEntry.Decorator(
                            content = ContentEntry.PlainText("Decorated text", null, null),
                            backgroundColor = ColorModel.Hex(0xFFFF0000),
                            insets = Insets(8, 8, 8, 8),
                            cornerRadius = 8,
                            margins = null,
                            action = null,
                        ),
                        ContentEntry.Space(8),
                        ContentEntry.Button(
                            text = "Button",
                            height = 37,
                            style = null,
                            containerColor = null,
                            action = ActionModel.Category(id = "id"),
                            insets = null
                        )
                    ),
                    weights = listOf(0f, 1f, 0f),
                    insets = Insets(16, 0, 16, 0),
                    action = null,
                ),
                anchorState = AnchorState(),
                onActionClicked = {},
                actionButton = null,
                onTextActionClicked = {},
                isMetrics = false,
            )
        }
    }
}